module.exports = __webpack_public_path__ + "img/status_processing_icon.44a16084.svg";